import styles from "./NotAvailable.module.scss";
import { RecommendationsUI } from "../../../Recommendations/RecommendationsUI";
import { NotifyMe } from "./NotifyMe/NotifyMe";
import { NotifiableEvent } from "../../../../types/types";
import { useDeferredValue } from "react";
import { CustomerNotifiableEvents } from "../../../../types/prodcatBaseTypes";

interface Props {
  pimProductId: string;
  skuId: string;
  customerNotifiableEvents: CustomerNotifiableEvents;
  notificationsApiBaseUrl: string;
  notificationsApiKey: string;
  oosPlacementId: string;
  isSelected: boolean;
}

export const NotAvailable = ({
  pimProductId,
  skuId,
  customerNotifiableEvents,
  notificationsApiBaseUrl,
  notificationsApiKey,
  oosPlacementId,
  isSelected,
}: Props) => {
  const notifiableEventType = getNotifiableEventType(customerNotifiableEvents);
  const deferredSkuId = useDeferredValue(skuId);

  return (
    <div
      id="notavailable:container"
      data-testid="notavailable:container"
      className={styles.notAvailable}
    >
      <NotifyMe
        pimProductId={pimProductId}
        skuId={skuId}
        // @ts-ignore
        notifiableEventType={notifiableEventType}
        notificationsApiBaseUrl={notificationsApiBaseUrl}
        notificationsApiKey={notificationsApiKey}
        isSelected={isSelected}
      />
      <div
        id="notavailable:recommendations"
        className={styles.recsPanelWrapper}
      >
        <RecommendationsUI
          placement={oosPlacementId}
          pimProductId={pimProductId}
          skuId={deferredSkuId}
          maxProductsPerPage="3"
        />
      </div>
    </div>
  );
};

export function getNotifiableEventType(
  customerNotifiableEvents: CustomerNotifiableEvents,
) {
  const allNotifiableEventTypesInPriorityOrder: NotifiableEvent[] = [
    "backInStock",
    "onRelease",
    "onPreorderLaunch",
    "newlyInStock",
  ];
  const notifiableEvents = allNotifiableEventTypesInPriorityOrder.filter(
    (eventType) => customerNotifiableEvents[eventType],
  );

  return notifiableEvents[0];
}
